var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPortHole = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1433 905"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 716.5,
  cy: 452.5,
  r: 452.5,
  stroke: "#000",
  strokeOpacity: 0.75,
  strokeWidth: 40
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M2087-13.5H-635v932h2722zm-1371 917c249.633 0 452-202.367 452-452S965.633-.5 716-.5s-452 202.367-452 452 202.367 452 452 452"
})));
export default SvgPortHole;